<div class="col-12 mb-3 flex items-center justify-between mt-3">
  <!-- Left Content -->
  <div class="flex flex-col">
    <span class="text-md font-semibold text-gray-900">
      Applicable Tasks Overview
    </span>

    <span class="text-2sm font-medium text-gray-500">
      View total assigned tasks across different steps
    </span>
  </div>

  <!-- Right Count -->
  <div
    class="flex items-center gap-2 px-4 py-2 rounded-xl border badge badge-light-primary"
  >
    <span class="text-sm font-semibold">Total Count : </span>

    <span
      class="min-w-[28px] h-[28px] flex items-center justify-center rounded-lg text-sm font-medium px-2 text-white badge badge-default-primary"
    >
      {{ totalTaskCount }}
    </span>
  </div>
</div>

<div
  class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6"
  *ngIf="isLoading"
>
  <div
    *ngFor="let s of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
    class="bg-white dark:bg-coal-700 border rounded-xl p-5 flex flex-col items-center justify-center relative"
  >
    <!-- Skeleton Bookmark Icon -->
    <div class="absolute top-0 left-3">
      <div
        class="shimmer-item bg-gray-300 dark:bg-coal-700 w-7 h-7 rounded"
      ></div>
    </div>

    <!-- Skeleton App Logo -->
    <div
      class="shimmer-item bg-gray-300 dark:bg-coal-700 rounded w-14 h-10 mb-4 mt-3"
    ></div>

    <!-- Skeleton App Name -->
    <div
      class="shimmer-item bg-gray-300 dark:bg-coal-700 w-24 h-4 rounded mb-2"
    ></div>

    <!-- Skeleton Description -->
    <div
      class="shimmer-item bg-gray-300 dark:bg-coal-700 w-36 h-4 rounded"
    ></div>
  </div>
</div>
<div class="graph-card flex justify-center overflow-y-auto gap-3">
  <div
    *ngIf="!isLoading && fieldsData.length > 0"
    class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-4 mt-2 w-full max-w-6xl"
  >
    <ng-container *ngFor="let item of fieldsData">
      <div
        class="border border-gray-200 rounded-xl p-3 flex flex-row items-center justify-between hover:bg-secondary-active transition-shadow"
      >
        <div class="flex items-center gap-4">
          <!-- Icon -->
          <div
            class="w-16 h-16 rounded-2xl bg-green-50 flex items-center justify-center"
          >
            <img
              src="./assets/media/icons/taskCount.png"
              class="w-12 h-12 object-contain"
            />
          </div>

          <!-- Text -->
          <div class="flex flex-col">
            <span
              class="text-md font-semibold text-gray-900 leading-none"
              [title]="item.module"
            >
              {{ item.module }}
            </span>

            <span class="text-2sm text-gray-500 mt-1"> Total Tasks </span>
          </div>
        </div>

        <!-- Right Count -->
        <div
          class="text-2xl font-semibold text-gray-800 leading-none"
          [title]="item.taskCount"
        >
          {{ item.taskCount }}
        </div>
      </div>
    </ng-container>
  </div>
</div>
<div
  class="flex flex-1 items-center justify-center text-center flex-col graph-card"
  *ngIf="fieldsData.length == 0"
>
  <span class="text-md text-gray-900 font-medium">No Data Available</span>
  <span class="text-sm text-gray-800">There is no data to display yet</span>
</div>
<div class="separator mt-1"></div>
